// extracted by mini-css-extract-plugin
export default {"container":"LabelText_container__rpc0Q","label":"LabelText_label__ah9qq","text":"LabelText_text__70Jdo"};